import { z } from 'zod'
import { type FirebaseCredentials } from '../../models/FirebaseCredentials'

export const FirebaseCredentialsDTO = z.object({
  access_token: z.string().min(1),
  expires_in: z.number().positive(),
  uuid: z.string().min(1)
})

export type FirebaseCredentialsDTO = z.infer<typeof FirebaseCredentialsDTO>

export function mapDTOToFirebaseCredentials (dto: FirebaseCredentialsDTO): FirebaseCredentials {
  return {
    accessToken: dto.access_token,
    expiresIn: dto.expires_in,
    uuid: dto.uuid
  }
}

export function mapFirebaseCredentialsToDTO (model: FirebaseCredentials): FirebaseCredentialsDTO {
  return {
    access_token: model.accessToken,
    expires_in: model.expiresIn,
    uuid: model.uuid
  }
}
